export default __webpack_public_path__ + "static/poster-435cedee4b4b9bbda399aba3584abb2f.png";